<template>
  <div>
    <v-btn block
      :color="themes.candidate.light.primaryActionButton"
      @click="login('google')"
      :loading="oauthing === 'google'"
    >
      <v-icon left>mdi-google</v-icon>
      Use Google
    </v-btn>
    <v-btn block
      @click="showEmailFields = showEmailFields === 0 ? null : 0"
      :color="themes.candidate.light.primaryActionButton"
      class="ma-0"
    >
      <v-icon left>mdi-email</v-icon>
      Use Email
    </v-btn>

    <v-expansion-panel v-model="showEmailFields" class="mt-2 elevation-0">
      <v-expansion-panel-content :class="themes.candidate.light.primaryActionButton">
        <v-card flat>
          <v-card-text class="pb-0">
            <v-form @submit.prevent="login" v-model="valid" ref="form">
              <v-text-field
                label="Email"
                v-model="auth.email"
                :rules="rules.email" required validate-on-blur
                type="email"
                hint="The address we'll use to send you notifications"
                ref="email"
                :color="themes.candidate.light.input"
                @keyup.enter="login"
                @focus="$emit('scroll')"
              />
              <v-text-field
                label="Password"
                v-model="auth.password"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :rules="rules.password"
                :type="showPassword ? 'text' : 'password'"
                class="input-group--focused"
                @click:append="showPassword = !showPassword"
                @keyup.enter="login"
                :color="themes.candidate.light.input"
              />
            </v-form>
          </v-card-text>

          <div class="text-xs-right pr-2 pb-2">
            <v-btn flat small
              @click="navigateTo('/password_reset')"
              :class="themes.candidate.light.link"
              class="pr-0 mr-0"
            >
              Forgot my password
            </v-btn>
          </div>

          <v-card-actions>
            <v-btn flat block
              @click="cancel"
              :color="themes.candidate.light.cancel"
              v-text="'Cancel'"
            />
            <v-btn block
              :color="themes.candidate.light.primaryActionButton"
              @click="login"
              type="submit"
              :loading="loading"
            >
              Log in
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$refs.email.focus()
  },

  props: { preventRedirect: { type: Boolean, default: () => false } },

  data() {
    return {
      // Model
      auth: {
        email: '',
        password: '',
      },
      // Validation
      valid: true,
      rules: {
        email: [
          v => !!v || 'Email is required',
          v => /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/.test(v) || 'Email must be valid',
        ],
        password: [v => !!v || 'Password is required'],
      },
      // Toggles
      showEmailFields: null, // index 0
      showPassword: false,
      loading: false,
      oauthing: null,
    }
  },

  methods: {
    navigateTo(path) {
      this.$emit('close')
      this.$router.push(path)
    },

    cancel() {
      if (this.$vuetify.breakpoint.smAndUp) this.$emit('close')
      this.auth = { email: '', password: '' }
    },

    login(oauth = null) {
      this.loading = true

      // Success callback
      const success = () => {
        this.loading = false
        this.oauthing = null
        this.$emit('input')
        this.$emit('done')
        this.redirect()
      }

      // OAuth
      if (oauth && ['google', 'facebook', 'linkedin'].indexOf(oauth) >= 0) {
        this.showEmailFields = null // close expansion panel
        this.oauthing = oauth
        // this.$store.dispatch('auth/provider', { provider: oauth }).then(success)
        this.$store.dispatch('auth/provider', { provider: oauth }).then(({ error }) => {
          if (!error) success()
          this.loading = false
          this.oauthing = null
        })
      }

      // Email
      if (this.showEmailFields === 0 && this.$refs.form.validate()) {
        this.$store
          .dispatch('auth/login', { auth: this.auth })
          .then(success)
          .catch(() => {})
          .finally(() => (this.loading = false))
      } else {
        this.loading = false
      }
    },

    redirect() {
      if (this.preventRedirect) return

      if (this.$store.getters['auth/role'] === 'client') {
        this.$router.push('/client/opportunities')
        return
      }

      this.$router.push('/dashboard')
    },
  },
}
</script>
